import React from 'react';

import ResponsiveTileView from '../components/responsiveTileView';
import Section from '../components/section';
import { Overview, Title } from '../components/text';

export default () => {
  return (
    <Section>
      <Title>Create beautiful sites and pages</Title>
      <Overview>
        Looking for how to get the most out of your SharePoint sites and pages?
        Follow the key topics to learn about customization and setting up sites
        for success.
      </Overview>
      <ResponsiveTileView
        tiles={[
          {
            title: 'Brand your site',
            description:
              'Learn how to effectively express your brand on SharePoint, including logos, site name, description and leveraging brand colors.',
            linkText: 'See branding guidance',
            linkTarget:
              'https://docs.microsoft.com/sharepoint/branding-sharepoint-online-sites-modern-experience',
          },
          {
            title: 'Get inspired',
            description:
              'Discover and get inspiration for the modern experiences you can build with SharePoint in Microsoft 365.',
            linkText: 'View SharePoint Look Book',
            linkTarget: 'https://sharepointlookbook.azurewebsites.net/',
            backgroundImage: 'images/lookBookBackground.jpg',
          },
          {
            title: 'Create custom themes',
            description: 'Create a theme and use them to customize your site.',
            linkText: 'Get guidance',
            linkTarget:
              'https://support.office.com/en-us/article/change-the-look-of-your-sharepoint-site-06bbadc3-6b04-4a60-9d14-894f6a170818',
          },
          {
            title: 'Navigation',
            description:
              'Guidance on navigation options, configuration, and best practices for organizing navigational IA.',
            linkText: 'Get guidance',
            linkTarget:
              'https://docs.microsoft.com/sharepoint/plan-navigation-modern-experience',
          },
          {
            title: 'Use News effectively',
            description:
              'Learn about News layouts and how to feature news on your site.',
            linkText: 'See more',
            linkTarget:
              'https://support.office.com/en-us/article/Use-the-News-web-part-on-a-SharePoint-page-C2DCEE50-F5D7-434B-8CB9-A7FEEFD9F165',
          },
          {
            title: 'Sections and columns',
            description:
              'Learn how to leverage columns within a section to achieve different page layouts.',
            linkText: 'Learn more',
            linkTarget:
              'https://support.office.com/en-us/article/add-or-remove-columns-on-a-page-fc491eb4-f733-4825-8fe2-e1ed80bd0899',
          },
        ]}
        gridRowsMedium={3}
        gridRowsLarge={2}
      />
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/sections/sitesPages.js